import { connect } from 'react-redux';
import { RootState } from '../../store/root';
import { RouteComponentProps } from 'react-router';
import { navigationSelectors } from '../common/navigation';
import selectors from './selectors';
import actions from './actions';

type IOwnProps = RouteComponentProps<{ tourCode: string }>;

const mapStateToProps = (state: RootState, props: IOwnProps) => {
  const tourCode = props.match.params.tourCode.trim();
  const tour = selectors.selectTourDetails(state);
  return {
    tourCode,
    tour,
    isLoading: selectors.selectIsLoading(state),
    error: selectors.selectError(state),
    returnToLocation: navigationSelectors.selectReturnToLocation(state),
    isLoadingTourRatings: selectors.selectIsLoadingTourRatings(state),
    numberOfComments: selectors.selectNumberOfComments(state),
    tourRatings: selectors.selectTourRatingVMs(state),
    requiresPurchase: selectors.selectRequiresPurchase(state),
  };
};

const dispatchProps = {
  fetchTourDetails: actions.fetchTourDetailsAsync.request,
};

export type IPageProps = ReturnType<typeof mapStateToProps> & typeof dispatchProps & IOwnProps;
export const connectPage = connect(mapStateToProps, dispatchProps);
